import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconStorage: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"storage, hdd, ssd"} maskId="square-filled-radius-0-stroke-1-IconStorage"><path d="M13.5 18.25H15V19.75H13.5V18.25Z" fill="currentColor"/><path d="M17.75 18.25H16.25V19.75H17.75V18.25Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M20 2H4V22H20V2ZM5 21V17H19L19 21H5Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconStorage;
